module.exports = "pegasus_template/assets/background-patterns/default-theme.jpg";